import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import "../PageProductFullDetailsMobile.scss";
import {
  FaAngleLeft,
  FaAngleRight,
  FaChevronUp,
  FaChevronDown,
  FaMinus,
  FaPlus,
  FaChevronRight,
  FaChevronLeft,
} from "react-icons/fa";
import ViewStarReview from "./viewStarReview";
import ViewAverageStarReview from "./ViewAverageStarReview";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../Components/AppProvider";

/**
 * Small inline SVG fallback (very small, reliable, no network)
 * - 100x100 gray "No Image" placeholder
 */
const INLINE_FALLBACK =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100'>
       <rect width='100' height='100' fill='#e6e6e6'/>
       <text x='50%' y='50%' font-size='12' dominant-baseline='middle' text-anchor='middle' fill='#777'>No image</text>
     </svg>`,
  );

export default function ProductFullDetailsMobile() {
  const location = useLocation();
  const initialIsLiked = location.state?.isLiked ?? false;
  //console.log("location.state?.isLiked:", location.state?.isLiked);
  const { productId } = useParams();
  const [ratings, setRatings] = useState([]);
  const [averageRating, setAverageRating] = useState(0);

  const [images, setImages] = useState([]);
  const [product, setProduct] = useState(null);
  const [imageIndex, setImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [stock, setStock] = useState(0);
  const [isLiked, setLike] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const scrollAmount = 200;

  const [modalOpen, setModalOpen] = useState(false);
  const [modalSrc, setModalSrc] = useState("");
  const [modalIsVideo, setModalIsVideo] = useState(false);
  const { setHasBagCount, setCustomerId, setHasWishlistCount } =
    useAppContext(); // ✅ grab bag count
  const navigate = useNavigate();

  const openMediaModal = (src, isVideo) => {
    setModalSrc(src);
    setModalIsVideo(isVideo);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalSrc("");
  };
  const handleAddToBagClick = async (quantity) => {
    setIsAdding(true); // disable button immediately

    try {
      await HandleAddToBag(productId, quantity);
      // Optionally show success toast or message
    } catch (err) {
      console.error(err);
    } finally {
      setIsAdding(false); // re-enable button if needed
    }
  };
  const HandleAddToBag = async (productId, quantity) => {
    setIsAdding(true);
    try {
      // Check auth first
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`,
        {
          credentials: "include",
        },
      );
      const data = await res.json();

      if (!data?.CP_ID) {
        // Ask for login
        const confirmLogin = window.confirm(
          "You need to be logged in to add this product to your bag. Do you want to log in now?",
        );

        if (!confirmLogin) return;

        // Save current state to restore after login
        localStorage.setItem(
          "redirectAfterLogin",
          JSON.stringify({
            path: window.location.pathname,
            scrollTop: window.scrollY, // ✅ Use window scroll position
            productId,
            quantity,
          }),
        );

        // Redirect to login page
        navigate("/login");
        return;
      }
      setCustomerId(data.CP_ID);
      // User is logged in, proceed to add
      const addRes = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/bag/add`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            CP_ID: data.CP_ID,
            PD_ID: productId,
            B_Quantity: quantity,
          }),
        },
      );

      const result = await addRes.json();
      if (addRes.ok) {
        setHasBagCount(true);
        alert(result.message);
        // ✅ Clear the saved state after successful add
        localStorage.removeItem("redirectAfterLogin");

        // Optionally: trigger a custom event to update UI if needed
        window.dispatchEvent(new Event("bagUpdated"));
        setModalOpen(false);
      } else {
        alert(result.error || "Failed to add to bag.");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    }
    setIsAdding(false);
  };
  useEffect(() => {
    if (initialIsLiked) {
      setLike(initialIsLiked);
    }
  }, [productId]);
  const fetchWishlistStatus = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`,
        {
          credentials: "include",
        },
      );
      const user = await res.json();
      if (!user?.CP_ID) return;

      const wishRes = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/wishlist/check/${productId}/${user.CP_ID}`,
      );
      const wishData = await wishRes.json();
      setLike(wishData?.isLiked || false);
    } catch (err) {
      console.error("Failed to fetch wishlist status:", err);
    }
  };
  const toggleLike = async () => {
    try {
      // 1️⃣ Check if logged in
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`,
        {
          credentials: "include",
        },
      );
      const data = await res.json();

      if (!data?.CP_ID) {
        const confirmLogin = window.confirm(
          "You need to be logged in to add/remove wishlist. Do you want to log in now?",
        );
        if (confirmLogin) navigate("/login");
        return;
      }

      const customerId = data.CP_ID;

      // 2️⃣ Determine command (add or remove)
      const command = isLiked ? "remove" : "add";

      // 3️⃣ Send request
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/wishlist/add-drop-wish/${productId}/${customerId}/${command}`,
        { method: "POST", credentials: "include" },
      );

      const result = await response.json();
      if (!response.ok)
        throw new Error(result.error || "Failed to toggle wishlist");

      // 4️⃣ Update UI instantly
      setLike(!isLiked);
      setHasWishlistCount(true);

      // ✅ Optional: trigger global refresh if your app listens for this
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (err) {
      console.error("Wishlist toggle failed:", err);
      alert("Something went wrong while updating your wishlist.");
    }
  };

  // helper: safe onError handler - only set fallback once
  const handleImgError = (e) => {
    const el = e.target;
    if (!el.dataset.fallback) {
      el.dataset.fallback = "true";
      el.src = INLINE_FALLBACK;
    }
  };

  // helper: safe video fallback (hide if source fails)
  const handleVideoError = (e) => {
    const video = e.target;
    // mark fallback so it won't repeatedly try
    if (!video.dataset.fallback) {
      video.dataset.fallback = "true";
      // hide or show poster; we'll hide the video element to avoid flicker
      video.style.display = "none";
    }
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/product/get-product-by-id-with-foreign/${productId}`,
        );
        const data = await res.json();

        if (!data.product) {
          console.warn("No product found for ID:", productId);
          setProduct(null);
          return;
        }

        const prod = data.product;
        setProduct(prod);

        const imageUrls = Array.isArray(prod.PD_ProductPicPath)
          ? prod.PD_ProductPicPath.map((img) => ({
              id: img,
              src: `${process.env.REACT_APP_BASE_URL}Assets/Products/${prod.PD_ID}/${img}`,
              name: img,
            }))
          : [];

        setImages(imageUrls);
      } catch (err) {
        console.error("Failed to fetch product", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  useEffect(() => {
    const fetchRatings = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/rate/get-rate-by-id/${productId}`,
        );
        const data = await res.json();
        //console.log("Ratings response:", data);

        if (Array.isArray(data.ratings)) {
          // Convert PR_RatingVal to number and ensure PR_ReviewPic is array (if backend already parsed it)
          const formattedRatings = data.ratings.map((r) => ({
            ...r,
            rateVal: parseFloat(r.PR_RatingVal) || 0,
            review: r.PR_ReviewText || "",
            PR_ReviewPic: Array.isArray(r.PR_ReviewPic)
              ? r.PR_ReviewPic
              : // try to parse string safely if backend didn't parse
                typeof r.PR_ReviewPic === "string"
                ? (() => {
                    try {
                      return JSON.parse(r.PR_ReviewPic);
                    } catch {
                      return [];
                    }
                  })()
                : [],
          }));

          setRatings(formattedRatings);
          setAverageRating(parseFloat(data.averageRating) || 0);
        } else {
          setRatings([]);
          setAverageRating(0);
        }
      } catch (err) {
        console.error("Failed to fetch ratings:", err);
      }
    };

    fetchRatings();
  }, [productId]);

  const scrollTopClick = () => {
    scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  };

  const scrollRightClick = () => {
    scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setShowLeft(scrollLeft > 0);
    setShowRight(scrollLeft + clientWidth < scrollWidth);
  };

  useEffect(() => {
    handleScroll();
  }, [images]);

  const formatDate = (val) => {
    if (!val) return "";
    try {
      return new Date(val).toISOString().slice(0, 10);
    } catch {
      return val;
    }
  };

  // Loading / not found
  if (isLoading)
    return <div className="loading">Loading product details...</div>;
  if (!product) return <div className="error">Product not found.</div>;
  const isProductAvailable = (
    PD_ProductType,
    PD_Stock,
    PD_Preorderdeadline,
  ) => {
    if (PD_ProductType === "onhand") {
      return PD_Stock > 0 ? true : false;
    } else if (PD_ProductType === "preorder") {
      return new Date(PD_Preorderdeadline) >= new Date() ? true : false;
    }
  };
  return (
    <>
      <div className="pfd-container">
        {/* PRODUCT IMAGES */}
        <div className="pfd-prod-with-details-container">
          <div className="pfd-prod-pic-container">
            <div className="pfd-preview-pic-wrapper">
              <div
                className={`pfd-prod-type-wrapper ${
                  isProductAvailable(
                    product.PD_ProductType,
                    product.PD_Stock,
                    product.PD_Preorderdeadline,
                  ) === false
                    ? "notAvailable-wrapper"
                    : ""
                }`}
              >
                <span
                  style={{
                    fontSize:
                      product.PD_ProductType === "onhand"
                        ? ""
                        : new Date(product.PD_Preorderdeadline) >= new Date()
                          ? ""
                          : "15px",
                  }}
                >
                  {product.PD_ProductType === "onhand"
                    ? product.PD_Stock > 0
                      ? `IN STOCK (${product.PD_Stock})`
                      : "OUT OF STOCK"
                    : new Date(product.PD_Preorderdeadline) >= new Date()
                      ? "PRE ORDER"
                      : "PRE ORDER ENDED"}
                </span>
              </div>

              <button
                className={`prod-wishlist-icon ${isLiked ? "is-active" : ""}`}
                onClick={toggleLike}
              >
                <svg width="18" height="16" viewBox="0 0 18 16">
                  <path
                    d="M9.01163699,14.9053769 C8.72930024,14.7740736 8.41492611,14.6176996 8.07646224,14.4366167 C7.06926649,13.897753 6.06198912,13.2561336 5.12636931,12.5170512 C2.52930452,10.4655288 1.00308384,8.09476443 1.00000218,5.44184117 C0.997549066,2.99198843 2.92175104,1.01242822 5.28303025,1.01000225 C6.41066623,1.00972036 7.49184369,1.4629765 8.28270844,2.2678673 L8.99827421,2.9961237 L9.71152148,2.26559643 C10.4995294,1.45849728 11.5791258,1.0023831 12.7071151,1.00000055 L12.7060299,1.00000225 C15.0693815,0.997574983 16.9967334,2.97018759 17.0000037,5.421337 C17.0038592,8.07662382 15.4809572,10.4530151 12.8850542,12.5121483 C11.9520963,13.2521931 10.9477036,13.8951276 9.94340074,14.4354976 C9.60619585,14.6169323 9.29297309,14.7736855 9.01163699,14.9053769 Z"
                    strokeWidth="1"
                  />
                </svg>
              </button>

              <button
                className="prev-pic-left"
                onClick={() => {
                  if (imageIndex > 0) setImageIndex(imageIndex - 1);
                  else setImageIndex(images.length - 1);
                }}
              >
                <FaAngleLeft />
              </button>

              <button
                className="prev-pic-right"
                onClick={() => {
                  if (imageIndex < images.length - 1)
                    setImageIndex(imageIndex + 1);
                  else setImageIndex(0);
                }}
              >
                <FaAngleRight />
              </button>

              <img
                src={images[imageIndex]?.src || INLINE_FALLBACK}
                alt={product?.PD_Name || "Product Image"}
                onError={handleImgError}
              />
            </div>

            <div className="pfd-pagi-pic-wrapper">
              {showLeft && (
                <button className="pagi-pic-left" onClick={scrollTopClick}>
                  <FaChevronLeft />
                </button>
              )}

              <div
                className="pfd-pagi-pic-scroll"
                ref={scrollRef}
                onScroll={handleScroll}
              >
                {images.map((img, index) => (
                  <img
                    className={imageIndex !== index ? "" : "imgActive"}
                    key={index}
                    onClick={() => setImageIndex(index)}
                    src={img.src}
                    alt={`Preview ${index}`}
                    onError={handleImgError}
                  />
                ))}
              </div>

              {showRight && (
                <button className="pagi-pic-right" onClick={scrollRightClick}>
                  <FaChevronRight />
                </button>
              )}
            </div>
          </div>
          {/* PRODUCT DETAILS */}
          <div className="pfd-prod-details-container">
            <div className="pfd-prod-name-wrapper">{product.PD_Name}</div>
            <div className="pfd-prod-details-wrapper">
              <table>
                <tbody>
                  <tr>
                    <th>MANUFACTURER:</th>
                    <td>{product.PM_Name}</td>
                  </tr>
                  <tr>
                    <th>SERIES:</th>
                    <td>{product.AS_Name}</td>
                  </tr>

                  {product.PD_ProductType === "onhand" ? (
                    <>
                      <tr>
                        <th>PRICE:</th>
                        <td>PHP {product.PD_OriginalPrice}</td>
                      </tr>
                      <tr>
                        <th>SALE PRICE:</th>
                        <td>PHP {product.PD_SalePrice}</td>
                      </tr>
                      <tr>
                        <th>DOWNPAYMENT:</th>
                        <td>PHP {product.PD_DownPayment}</td>
                      </tr>
                    </>
                  ) : (
                    <>
                      <tr>
                        <th>PRICE:</th>
                        <td>PHP {product.PD_OriginalPrice}</td>
                      </tr>
                      <tr>
                        <th>DOWNPAYMENT:</th>
                        <td>PHP {product.PD_DownPayment}</td>
                      </tr>
                      <tr>
                        <th>DEADLINE:</th>
                        <td>
                          {" "}
                          {isProductAvailable(
                            product.PD_ProductType,
                            product.PD_Stock,
                            product.PD_Preorderdeadline,
                          ) === true
                            ? formatDate(product.PD_Preorderdeadline)
                            : `${formatDate(product.PD_Preorderdeadline)} (ENDED)`}
                        </td>
                      </tr>
                      <tr>
                        <th>JAPAN ESTIMATED RELEASE DATE:</th>
                        <td>{product.PD_JapanEstmated}</td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
            {/* QUANTITY */}{" "}
            {isProductAvailable(
              product.PD_ProductType,
              product.PD_Stock,
              product.PD_Preorderdeadline,
            ) && (
              <div className="pfd-prod-quantity-wrapper">
                <table>
                  <tbody>
                    <tr>
                      <th>QUANTITY:</th>
                      <td>
                        <input
                          type="text"
                          value={quantity}
                          onChange={(e) => {
                            const onlyDigits = Number(
                              e.target.value.replace(/\D/g, "").slice(0, 11),
                            );
                            if (product.PD_ProductType === "onhand") {
                              if (product.PD_Stock < onlyDigits)
                                setQuantity(product.PD_Stock);
                              else setQuantity(onlyDigits || 1);
                            } else setQuantity(onlyDigits || 1);
                          }}
                        />
                        <button
                          className="minus"
                          onClick={() =>
                            quantity > 1 && setQuantity(quantity - 1)
                          }
                        >
                          <FaMinus />
                        </button>
                        <button
                          className="plus"
                          onClick={() => {
                            if (product.PD_ProductType === "onhand") {
                              if (product.PD_Stock > quantity)
                                setQuantity(quantity + 1);
                            } else setQuantity(quantity + 1);
                          }}
                        >
                          <FaPlus />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            {/* ORDER GUIDE */}
            <div className="pfd-prod-guide-wrapper">
              {product.PD_ProductType === "preorder" && (
                <>
                  <p>
                    **Please be aware that we cannot process orders past the PO
                    deadline, as stated by manufacturer/distributor**
                  </p>
                  <p>
                    **PH release is 1–2 months after Japan release. Please be
                    mindful that the ETA is based on manufacturer/distributor
                    estimates and can CHANGE.**
                  </p>
                </>
              )}
              <p>
                **BY PLACING AN ORDER, YOU ARE AGREEING TO OUR ORDER
                GUIDELINES.**
              </p>
              <p>
                You may visit our order guidelines <a href="#">here</a>.
              </p>
            </div>
            {/* ADD TO BAG */}{" "}
            {isProductAvailable(
              product.PD_ProductType,
              product.PD_Stock,
              product.PD_Preorderdeadline,
            ) && (
              <div className="pfd-prod-buttons-wrapper">
                <button
                  className="add-to-bag"
                  onClick={() => handleAddToBagClick(quantity)}
                  disabled={isAdding}
                >
                  {isAdding ? "ADDING..." : "ADD TO BAG"}
                </button>
              </div>
            )}
          </div>
        </div>
        {/* REVIEWS */}
        <div className="pfd-prod-review-container">
          <div className="review-title-header">
            <div className="review-title">
              <h1>PRODUCT RATINGS</h1>{" "}
              <p>
                {" "}
                ({ratings.length} review{ratings.length !== 1 ? "s" : ""})
              </p>
            </div>
            <div className="review-title-wrapper">
              <span>
                {averageRating || "0.0"} <small>out of 5</small>
              </span>
              <ViewAverageStarReview
                PD_ID={product.PD_ID}
                reviewValue={averageRating}
              />
            </div>
          </div>

          <div className="review-list">
            {ratings.length > 0 ? (
              [...ratings]
                .sort(
                  (a, b) =>
                    new Date(b.PR_Created_At).getTime() -
                    new Date(a.PR_Created_At).getTime(),
                )
                .map((r, i) => (
                  <div key={r.PR_ID || i} className="review-item">
                    <div className="review-header">
                      <div className="review-user">
                        <div className="review-user-info">
                          <span className="review-name">
                            {r.CP_Firstname} {r.CP_Lastname}
                          </span>
                          <span className="review-date">
                            {formatDate(r.PR_Created_At)}
                          </span>
                        </div>
                      </div>
                      <div className="star-wrapper">
                        <ViewStarReview reviewValue={parseFloat(r.rateVal)} />
                        <span>({r.rateVal})</span>
                      </div>
                    </div>

                    {r.review && <p className="review-text">{r.review}</p>}

                    {Array.isArray(r.PR_ReviewPic) &&
                      r.PR_ReviewPic.length > 0 && (
                        <div className="review-media">
                          {r.PR_ReviewPic.map((file, i) => {
                            const isVideo = file.endsWith(".mp4");
                            const src = `${process.env.REACT_APP_BASE_URL}Assets/rate/${r.PR_ID}/${file}`;

                            const handleImgError = (e) => {
                              const el = e.target;
                              if (!el.dataset.fallback) {
                                el.dataset.fallback = "true";
                                el.src = "/fallback.png";
                              }
                            };

                            return (
                              <div
                                key={i}
                                className={`media-item ${
                                  isVideo ? "video-thumb" : ""
                                }`}
                                onClick={() => openMediaModal(src, isVideo)}
                              >
                                {isVideo ? (
                                  <>
                                    <video
                                      className="media-video"
                                      src={src}
                                      preload="metadata"
                                      muted
                                      onError={(e) => {
                                        if (!e.target.dataset.fallback) {
                                          e.target.dataset.fallback = "true";
                                          e.target.style.display = "none";
                                        }
                                      }}
                                    />
                                    <div className="play-overlay">▶</div>
                                  </>
                                ) : (
                                  <img
                                    className="media-image"
                                    src={src}
                                    alt={`review-media-${i}`}
                                    loading="lazy"
                                    onError={handleImgError}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                  </div>
                ))
            ) : (
              <p className="no-reviews">No reviews yet.</p>
            )}
          </div>
        </div>
      </div>
      {modalOpen && (
        <div
          className="media-modal"
          onMouseDown={(e) => {
            // ✅ close only when clicking background, not modal content
            if (e.target.classList.contains("media-modal")) {
              closeModal();
            }
          }}
        >
          <div
            className="media-modal-content"
            onMouseDown={(e) => e.stopPropagation()} // ✅ prevent closing
          >
            <button
              className="modal-close"
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}
            >
              ✕
            </button>

            {modalIsVideo ? (
              <video src={modalSrc} controls autoPlay />
            ) : (
              <img src={modalSrc} alt="Full view" />
            )}
          </div>
        </div>
      )}
    </>
  );
}
